import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const TrophyIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('TrophyIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path d="M12,22c-0.55,0-1-0.45-1-1v-4c0-0.55,0.45-1,1-1s1,0.45,1,1v4C13,21.55,12.55,22,12,22z" />
    <path d="M16,22H8c-0.55,0-1-0.45-1-1s0.45-1,1-1h8c0.55,0,1,0.45,1,1S16.55,22,16,22z" />
    <path
      d="M6.08,13c-2.21,0-4-1.79-4-4V6c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1s-0.45,1-1,1h-2v2c0,1.1,0.9,2,2,2c0.55,0,1,0.45,1,1
	S6.63,13,6.08,13z"
    />
    <path
      d="M17.92,13c-0.55,0-1-0.45-1-1s0.45-1,1-1c1.1,0,2-0.9,2-2V7h-2c-0.55,0-1-0.45-1-1s0.45-1,1-1h3c0.55,0,1,0.45,1,1v3
	C21.92,11.21,20.13,13,17.92,13z"
    />
    <path
      d="M12,17.66c-3.26,0-5.92-2.66-5.92-5.92V4c0-0.55,0.45-1,1-1h9.84c0.55,0,1,0.45,1,1v7.74C17.92,15.01,15.26,17.66,12,17.66z
	 M8.08,5v6.74c0,2.16,1.76,3.92,3.92,3.92s3.92-1.76,3.92-3.92V5H8.08z"
    />
  </svg>
);

export default TrophyIcon;
